export const EDITOR_BOLD = 'EDITOR_BOLD';
export const EDITOR_ITALIC = 'EDITOR_ITALIC';
export const EDITOR_FONT_SIZE = 'EDITOR_FONT_SIZE';
export const EDITOR_FONT_FAMILY = 'EDITOR_FONT_FAMILY';
export const EDITOR_TEXT_COLOR = 'EDITOR_TEXT_COLOR';

export const defaultEditorStyle = {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: '100%',
    fontFamily: '',
    color: '#000000'
};

export const availableStyles = {
    fontWeight: ['normal', 'bold'],
    fontStyle: ['normal', 'italic'],
    fontSize: ['66%', '83%', '100%', '117%'],
    fontFamily: [
        'Arial, Helvetica, sans-serif',
        'Comic Sans MS, cursive',
        'Courier New, Courier, monospace',
        'Georgia, serif',
        'Lucida Sans Unicode, Lucida Grande, sans-serif',
        'Tahoma, Geneva, sans-serif',
        'Times New Roman, Times, serif',
        'Trebuchet MS, Helvetica, sans-serif',
        'Verdana, Geneva, sans-serif'
    ],
    color: [
        '#000000', '#800000', '#8B4513', '#2F4F4F', '#008080', '#000080',
        '#4B0082', '#696969', '#B22222', '#A52A2A', '#DAA520', '#006400',
        '#40E0D0', '#0000CD', '#800080', '#808080', '#FF8C00', '#FFD700',
        '#008000', '#00FFFF', '#0000FF', '#EE82EE', '#A9A9A9', '#FFA07A',
        '#FFA500', '#FFFF00', '#00FF00', '#AFEEEE', '#ADD8E6', '#DDA0DD'
    ]
};

export const smileys = [
    {
        'emoji': '😀',
        'desc': 'Smile'
    },
    {
        'emoji': '😉',
        'desc': 'Wink'
    },
    {
        'emoji': '😁',
        'desc': 'Laugh'
    },
    {
        'emoji': '😎',
        'desc': 'Cool'
    },
    {
        'emoji': '😋',
        'desc': 'Savouring'
    },
    {
        'emoji': '🤣',
        'desc': 'rofl'
    },
    {
        'emoji': '😱',
        'desc': 'Screaming'
    },
    {
        'emoji': '💋',
        'desc': 'Kiss'
    },
    {
        'emoji': '😍',
        'desc': 'Heart Eyes'
    },
    {
        'emoji': '😵',
        'desc': 'Dizzy'
    },
    {
        'emoji': '🥵',
        'desc': 'Overheated'
    },
    {
        'emoji': '🥳',
        'desc': 'Partying'
    },
    {
        'emoji': '😷',
        'desc': 'Mask'
    },
    {
        'emoji': '😐',
        'desc': 'Indecision'
    },
/*
    {
        'emoji': '😕',
        'desc': 'Confused'
    },
 */
    {
        'emoji': '🙁',
        'desc': 'Sad'
    },
    {
        'emoji': '😢',
        'desc': 'Crying'
    },
    {
        'emoji': '😡',
        'desc': 'Angry'
    },
    {
        'emoji': '🤐',
        'desc': 'Lips Sealed'
    },
    {
        'emoji': '😴',
        'desc': 'Sleeping'
    },
    {
        'emoji': '😲',
        'desc': 'Surprise'
    },
    {
        'emoji': '😳',
        'desc': 'Embarrassed'
    },
    {
        'emoji': '😇',
        'desc': 'Angel'
    },
    {
        'emoji': '😈',
        'desc': 'Devil'
    },
    {
        'emoji': '👍',
        'desc': 'Thumbs Up'
    },

];


// WEBPACK FOOTER //
// ./src/constants/chatEditorOwn.js